import editorClasses from '../components/AhaEditorV2.module.css';

/**
 * Used to detect if an element is inside a focusable ancestor.
 *
 * We use this in the helper below to ignore mousedown events inside a focusable element,
 * but for other elements we will call `preventDefault` to avoid toolbars and other elements
 * from causing the editor to lose focus.
 */
export function eventIsInsideFocusableElement(event: Event) {
  return Boolean(
    event
      .composedPath()
      .some(
        (el) =>
          el instanceof HTMLElement &&
          el.matches(
            `input, textarea, select, [contentEditable=true], [tabindex]:not(.${editorClasses.container})`
          )
      )
  );
}

/**
 * Handlers applied to toolbars to prevent focusable elements
 * Note these musn't stop propagation completely, as in React 18 this will prevent
 * external handlers (e.g. on aha-menu) from working
 */
export const cancelEventHandlersOutsideFocusableElements = {
  onMouseDown: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!eventIsInsideFocusableElement(event.nativeEvent)) {
      event.preventDefault();
    }
  },
  onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (!eventIsInsideFocusableElement(event.nativeEvent)) {
      event.preventDefault();
    }
  },
};
